import { Routes, Route } from "react-router-dom";
import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import QuestionnaireLayout from "layouts/questionnaires";
import EvaluacionLayout from "layouts/evaluacion";
import InformeLayout from "layouts/informe";
import Home from "views/home";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="rtl/*"
          element={
            <ProtectedRoute>
              <RtlLayout />
            </ProtectedRoute>
          }
        />
        <Route path="questionnaires/*" element={<QuestionnaireLayout />} />
        <Route path="evaluacion/*" element={<EvaluacionLayout />} />
        <Route path="informe/*" element={<InformeLayout />} />
        {/* La raíz muestra la landing pública, no el panel. */}
        <Route path="/" element={<Home />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
